var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path3, _rect7, _path4, _rect8, _rect9, _rect10, _rect11, _path5, _rect12, _rect13, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectFloor2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3406,
    height: 2369,
    viewBox: "0 0 3406 2369",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: 4,
    d: "M2361.98 837H3106V2026H2338V1427.49H2340.85V1414.44H2593.5V1313.1H2361.98V837Z",
    fill: "#A0BA3B",
    fillOpacity: 0.48,
    stroke: "#A0BA3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "2_12",
    d: "M1631.58 1386H1863V1684H1624.84V1604.88H1599V1428.19H1631.58V1386Z",
    fill: "#A0BA3B",
    fillOpacity: 0.48,
    stroke: "#A0BA3B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "2_13",
    x: 1863,
    y: 1421,
    width: 234,
    height: 263,
    fill: "#A0BA3B",
    fillOpacity: 0.48,
    stroke: "#A0BA3B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "2_14",
    x: 2097,
    y: 1421,
    width: 241,
    height: 263,
    fill: "#A0BA3B",
    fillOpacity: 0.48,
    stroke: "#A0BA3B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "2_15",
    x: 2097,
    y: 1764,
    width: 241,
    height: 262,
    fill: "#A0BA3B",
    fillOpacity: 0.48,
    stroke: "#A0BA3B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "2_16",
    x: 1863,
    y: 1764,
    width: 234,
    height: 262,
    fill: "#A0BA3B",
    fillOpacity: 0.48,
    stroke: "#A0BA3B"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "2_17",
    x: 1632,
    y: 1764,
    width: 231,
    height: 262,
    fill: "#A0BA3B",
    fillOpacity: 0.48,
    stroke: "#A0BA3B"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "2_18",
    x: 1401,
    y: 1764,
    width: 231,
    height: 262,
    fill: "#A0BA3B",
    fillOpacity: 0.48,
    stroke: "#A0BA3B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "2_19",
    d: "M1098.65 1913.13L1341.15 1754H1401V2026H1172.9L1098.65 1913.13Z",
    fill: "#A0BA3B",
    fillOpacity: 0.48,
    stroke: "#A0BA3B"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "2_20",
    x: 1163.62,
    y: 1577.28,
    width: 245.168,
    height: 238.499,
    transform: "rotate(56.7447 1163.62 1577.28)",
    fill: "#A0BA3B",
    fillOpacity: 0.48,
    stroke: "#A0BA3B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "2_21",
    d: "M1048 1344.5L1104.5 1429.5L1126.5 1460.5L1116 1467.5L1130 1488L1157.5 1468.5L1204.35 1540.42L959.561 1700.94L826.994 1489.51L1048 1344.5Z",
    fill: "#A0BA3B",
    fillOpacity: 0.48,
    stroke: "#A0BA3B"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "2_22",
    x: 928.33,
    y: 1162.05,
    width: 218.182,
    height: 264.46,
    transform: "rotate(56.7447 928.33 1162.05)",
    fill: "#A0BA3B",
    fillOpacity: 0.48,
    stroke: "#A0BA3B"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "2_23",
    x: 801.344,
    y: 968.621,
    width: 231.214,
    height: 264.46,
    transform: "rotate(56.7447 801.344 968.621)",
    fill: "#A0BA3B",
    fillOpacity: 0.48,
    stroke: "#A0BA3B"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "2_24",
    x: 674.209,
    y: 774.967,
    width: 231.659,
    height: 264.46,
    transform: "rotate(56.7447 674.209 774.967)",
    fill: "#A0BA3B",
    fillOpacity: 0.48,
    stroke: "#A0BA3B"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "2_25",
    x: 534.734,
    y: 562.496,
    width: 254.195,
    height: 264.46,
    transform: "rotate(56.7447 534.734 562.496)",
    fill: "#A0BA3B",
    fillOpacity: 0.48,
    stroke: "#A0BA3B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "2_26",
    d: "M821 378L959.519 589.006L738.697 733.812L599 522L821 378Z",
    fill: "#A0BA3B",
    fillOpacity: 0.48,
    stroke: "#A0BA3B"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "2_27",
    x: 959.766,
    y: 589.254,
    width: 232.042,
    height: 263.998,
    transform: "rotate(56.7447 959.766 589.254)",
    fill: "#A0BA3B",
    fillOpacity: 0.48,
    stroke: "#A0BA3B"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "2_28",
    x: 1087.15,
    y: 783,
    width: 232.042,
    height: 264.46,
    transform: "rotate(56.7447 1087.15 783)",
    fill: "#A0BA3B",
    fillOpacity: 0.48,
    stroke: "#A0BA3B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "2_29",
    d: "M1361.79 1143.47L1493.69 1343.86L1219.35 1523.77L1166.5 1443.5L1187.45 1429.54L1106.44 1303.04L1333.85 1154.92L1337.35 1159.92L1361.79 1143.47Z",
    fill: "#A0BA3B",
    fillOpacity: 0.48,
    stroke: "#A0BA3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectFloor2);
export default __webpack_public_path__ + "static/media/select_floor_2.82af8ac70aaae684194945aaf0a88525.svg";
export { ForwardRef as ReactComponent };